// Dock yüksekliği, alt konumu ve liste boşluğu aynı geometriden türetilir.
// Güvenli alan ekranda eklenir; home indicator olmayan cihazlarda sıfırdır.
export const floatingDockMetrics = {
  tabSize: 44,
  verticalPadding: 6,
  bottomOffset: 16,
  contentGap: 16,
} as const;

export const floatingDockHeight = floatingDockMetrics.tabSize + 2 * floatingDockMetrics.verticalPadding;
export const floatingDockScrollInset = floatingDockHeight + floatingDockMetrics.bottomOffset;
export const floatingDockContentInset = floatingDockScrollInset + floatingDockMetrics.contentGap;
